<template>
  <div style="position: relative">
    <v-card flat>
      <div id="controlsContainer">
        <div
          class="card-title table-controls px-3 d-flex align-center justify-space-between"
        >
          <div>
            <!-- CRUD buttons -->
            <!-- dialog for creating item -->
            <crud-button
              x-large
              color="light-blue lighten-2"
              @clicked="create()"
              icon="fa-plus"
              :tooltip="$t('global.crud.button.add')"
            />
          </div>
          <!-- center side -->
          <div>
            <!-- Search by fields -->
            <!-- Search in table -->
            <v-container id="filterContainer">
              <v-row>
                <v-col sm="6" cols="12">
                  <v-text-field
                    v-model="filter.allFields"
                    :label="$t('global.datatable.search')"
                    append-icon="fas fa-search"
                    single-line
                  ></v-text-field>
                </v-col>
                <v-col sm="6" cols="12">
                  <v-select
                    v-model="filter.deletedItems"
                    :items="deletedItemsValues"
                    :label="$t('global.status')"
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
            <!-- clear filters -->
          </div>
          <!-- right side -->
          <div>
            <!-- Refresh table -->
            <crud-button
              large
              color="blue"
              @clicked="refreshItemsView()"
              icon="fa-sync-alt"
              :tooltip="$t('global.crud.buttons.refreshTable')"
            />
            <ExportExcel url="/productsTypes" :filter="this.filter" />
            <ImportExcel url="/productsTypes" @done="search" />
          </div>
        </div>
      </div>
      <div id="dataContainer">
        <!-- Table -->
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :page.sync="pagination.page"
          :server-items-length="pagination.totalItems"
          :no-results-text="$t('global.datatable.noMatchingResults')"
          :no-data-text="$t('global.datatable.noDataAvailable')"
          :footer-props="{
            'items-per-page-options': rowsPerPageItems,
            'show-first-last-page': true,
            'show-current-page': true
          }"
          :loading="loading"
          light
          multi-sort
          dense
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr
                v-for="item in items"
                :key="item.code"
                :title="item.description"
              >
                <td>
                  <!-- Edit record -->
                  <crud-button
                    x-small
                    color="orange"
                    icon="fa-pen"
                    :tooltip="$t('global.crud.buttons.edit')"
                    @clicked="edit(item.code)"
                  ></crud-button>

                  <!-- Delete record -->
                  <crud-button
                    v-if="
                      item.deletionDate === undefined ||
                        item.deletionDate === null
                    "
                    x-small
                    color="red"
                    icon="fa-trash"
                    :tooltip="$t('global.crud.buttons.delete')"
                    @clicked="suspend(item.code)"
                  ></crud-button>
                  <!-- Active record -->
                  <crud-button
                    v-else
                    x-small
                    color="green"
                    icon="fa-redo"
                    :tooltip="$t('global.crud.buttons.restore')"
                    @clicked="restore(item.code)"
                  ></crud-button>
                  <crud-button
                    x-small
                    color="orange"
                    icon="fa-bars"
                    :tooltip="$t('global.crud.buttons.parametrizeByDelegation')"
                    @clicked="productsTypesOperations(item.code)"
                  ></crud-button>
                </td>
                <td>{{ item.code }}</td>
                <td>{{ item.defaultTime }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <v-dialog v-model="dialog" max-width="600" persistent no-click-animation>
      <validation-observer ref="obs" v-slot="{ invalid, validated, passes }">
        <v-card>
          <v-toolbar dark color="primary" dense flat>
            <v-toolbar-title class="white--text">
              {{ formTitle }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="close()">
              <v-icon>fas fa-times</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="details-list">
            <v-form>
              <v-layout row wrap>
                <v-flex class="sm12">
                  <validation-provider
                    :name="$t('productsTypes.code')"
                    rules="required|max:30"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      :label="$t('productsTypes.code')"
                      v-model="item.code"
                      :disabled="editMode"
                      required
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex class="sm12">
                  <validation-provider
                    :name="$t('productsTypes.defaultTime')"
                    rules="required|max:30"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      :label="$t('productsTypes.defaultTime')"
                      v-model="item.defaultTime"
                      required
                      :error-messages="errors"
                      counter="30"
                    ></v-text-field>
                  </validation-provider>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black" text @click.native="close()">
              {{ $t("global.buttons.close") }}
            </v-btn>
            <v-btn v-if="editMode" color="orange" text @click="passes(update)">
              {{ $t("global.buttons.update") }}
            </v-btn>
            <v-btn v-else color="green" text @click="passes(save)">
              {{ $t("global.buttons.create") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </validation-observer>
    </v-dialog>
  </div>
</template>

<script>
import CrudButton from "@/components/Button.vue";
import localhttp from "../js/https-commons";
import ExportExcel from "@/components/ExportExcel.vue";
import ImportExcel from "@/components/ImportExcel.vue";

const CONTEXT = "/productsTypes";
const CONTEXT_PRODUCTS_TYPES_TYPES = "/productsTypes";
const ENTITY_NAME = "productType.";

export default {
  components: {
    CrudButton,
    ExportExcel,
    ImportExcel
  },
  name: "ProductsTypes",
  data: () => ({
    hover: false,
    loading: false,
    searchTableWaiting: false,
    editMode: false,
    dialog: false,
    item: {},
    items: [],
    filter: {
      allFields: "",
      code: "",
      deletedItems: "ACTIVE"
    },
    options: {},
    pagination: {
      totalItems: 0,
      page: 1
    },
    rowsPerPageItems: [10, 20, 30, 40],
    productsTypes: {
      isLoading: false,
      entries: [],
      search: null,
      value: "",
      isEdit: false
    },
    productsTypesFilter: {
      isLoading: false,
      entries: [],
      search: null,
      value: "",
      isEdit: false
    }
  }),
  computed: {
    deletedItemsValues: function() {
      return [
        { text: this.$t("global.status.all"), value: "ALL" },
        { text: this.$t("global.status.active"), value: "ACTIVE" },
        { text: this.$t("global.status.deleted"), value: "DELETED" }
      ];
    },
    formTitle() {
      return this.editMode
        ? this.$t("productsTypes.title.edit")
        : this.$t("productsTypes.title.new");
    },
    headers() {
      return [
        {
          text: this.$t("global.datatable.header.actions"),
          value: "actions",
          sortable: false
        },
        {
          text: this.$t("productsTypes.datatable.code"),
          value: ENTITY_NAME + "code"
        },
        {
          text: this.$t("productsTypes.datatable.defaultTime"),
          value: ENTITY_NAME + "defaultTime"
        }
      ];
    }
  },
  watch: {
    options: {
      handler() {
        this.search();
      },
      deep: true
    },
    "pagination.totalItems": {
      handler() {
        this.pagination.page = 1;
      },
      deep: true
    },
    "filter.allFields": function() {
      if (!this.searchTableWaiting) {
        setTimeout(() => {
          this.search();
          this.searchTableWaiting = false;
        }, 500);
      }
      this.searchTableWaiting = true;
    },
    "productsTypes.search": function(value) {
      this.preLoadGenericSearchEntity(
        value,
        this.productsTypes,
        CONTEXT_PRODUCTS_TYPES_TYPES
      );
    },
    "productsTypesFilter.search": function(value) {
      this.preLoadGenericSearchEntity(
        value,
        this.productsTypesFilter,
        CONTEXT_PRODUCTS_TYPES_TYPES
      );
    }
  },
  methods: {
    search() {
      console.debug("Search elements");

      // Items have already been requested
      if (this.loading) return;

      this.loading = true;

      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      this.filter.sortBy = sortBy;
      this.filter.sortDesc = sortDesc;
      this.filter.page = page;
      this.filter.itemsPerPage = itemsPerPage;

      localhttp
        .post(CONTEXT + "/allPagination", this.filter)
        .then(response => {
          this.pagination.totalItems = response.data.totalElements;
          this.items = response.data.content;
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
          this.$showError();
        });
    },
    preLoadGenericSearchEntity(value, object, context, aditionalFilter) {
      if (!object.isLoadingWaiting) {
        setTimeout(() => {
          this.genericSearchEntity(object, context, aditionalFilter);
          object.isLoadingWaiting = false;
        }, 500);
      }
      object.value = value;
      object.isLoadingWaiting = true;
    },
    async genericSearchEntity(object, context, aditionalFilter) {
      console.debug("genericSearchEntity");
      if (!object.isEdit || object.value === null || object.value === "")
        return;

      if (object.isLoading) return;

      object.isLoading = true;

      let filterGeneric = {
        allFields: object.value
      };
      if (aditionalFilter !== undefined) {
        Object.keys(aditionalFilter).forEach(
          key => (filterGeneric[key] = aditionalFilter[key])
        );
      }

      // Lazily load input items
      localhttp
        .post(context + "/allFilter", filterGeneric)
        .then(response => {
          console.debug(response.data);
          object.entries = response.data;
        })
        .catch(e => {
          console.log(e);
          this.$showError();
        })
        .finally(() => (object.isLoading = false));
    },
    create() {
      console.debug("Create element");
      this.editMode = false;
      this.resetDialog();
      this.dialog = true;
    },
    async save() {
      console.debug("Save form");
      localhttp
        .post(CONTEXT + "/create", this.item)
        .then(response => {
          console.log(response.data);
          this.close();
          this.search();
        })
        .catch(e => {
          console.log(e);
          this.$showErrorCode(e.response.status);
        });
    },
    edit(id) {
      console.debug("Edit element " + id);
      this.editMode = true;
      this.resetDialog();
      localhttp
        .get(CONTEXT + "/" + id)
        .then(response => {
          this.item = response.data;
          this.dialog = true;
        })
        .catch(e => {
          console.log(e);
          this.$showErrorCode(e.response.status);
        });
    },
    async update() {
      console.debug("Update form");
      localhttp
        .put(CONTEXT + "/update/" + this.item.code, this.item)
        .then(response => {
          console.log(response.data);
          this.close();
          this.search();
        })
        .catch(e => {
          console.log(e);
          this.$showErrorCode(e.response.status);
        });
    },
    async suspend(id) {
      console.debug("Suspend element " + id);
      if (
        await this.$root.$confirm(
          this.$t("global.confirm"),
          this.$t("global.action.suspend.confirm"),
          { color: "blue" }
        )
      ) {
        localhttp
          .put(CONTEXT + "/delete/" + id)
          .then(response => {
            console.log(response.data);
            this.search();
          })
          .catch(e => {
            console.log(e);
            this.$showErrorCode(e.response.status);
          });
      }
    },
    refreshItemsView() {
      console.debug("Refresh table");
      this.search();
    },
    restore(id) {
      console.debug("Restore element " + id);
      localhttp
        .put(CONTEXT + "/activate/" + id)
        .then(response => {
          console.log(response.data);
          this.search();
        })
        .catch(e => {
          console.log(e);
          this.$showErrorCode(e.response.status);
        });
    },
    close() {
      this.dialog = false;
    },
    productsTypesOperations(code) {
      this.$router.push({
        name: "productsTypesOperations",
        query: {
          productType: code
        }
      });
    },
    resetDialog() {
      this.item = {};
      this.resetProductsTypesSearch();
      requestAnimationFrame(() => {
        if (this.$refs.obs !== undefined) {
          this.$refs.obs.reset();
        }
      });
    },
    resetProductsTypesSearch() {
      this.productsTypes.search = "";
      this.productsTypes.entries = [];
    }
  }
};
</script>
